export const validateEmail = (email) => {
  if (!email) return 'Email is required';
  if (!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email.trim())) return 'Invalid email';
  return '';
};
export const validatePassword = (p) => {
  if (!p) return 'Password is required';
  if (p.length < 6) return 'Min 6 characters';
  if (!/\d/.test(p)) return 'Must contain a number';
  if (!/[a-zA-Z]/.test(p)) return 'Must contain a letter';
  return '';
};
export const validateName = (n) => {
  if (!n?.trim()) return 'Name is required';
  if (n.trim().length < 2) return 'Min 2 characters';
  return '';
};
export const validateConfirmPassword = (p, c) => {
  if (!c) return 'Confirm your password';
  if (p !== c) return 'Passwords do not match';
  return '';
};
export const getPasswordStrength = (p) => {
  if (!p) return { score: 0, label: '' };
  let s = 0;
  if (p.length >= 6) s++; if (p.length >= 10) s++;
  if (/[a-z]/.test(p) && /[A-Z]/.test(p)) s++;
  if (/\d/.test(p)) s++; if (/[^a-zA-Z0-9]/.test(p)) s++;
  if (s <= 2) return { score: 1, label: 'Weak' };
  if (s <= 3) return { score: 2, label: 'Medium' };
  if (s <= 4) return { score: 3, label: 'Strong' };
  return { score: 4, label: 'Very Strong' };
};
